// extracted by mini-css-extract-plugin
module.exports = {"footer-one":"link-m__footer-one__wY0ix","menu":"link-m__menu__2-qGR","footer":"link-m__footer__1iQcO"};